<template>
  <div style="display: contents;">
    <b-row>
      <b-col md="8">
        <h5 class="result-summary"><translate>Booking general details</translate> <span class="text-dark border font-weight-bold rounded px-2 bg-light float-right">{{ booking.id }}</span></h5>
        <table class="table table-striped border">
            <tr>
              <td><b><translate>Booking date</translate>:</b> {{ getDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
              <td>
                <b><translate>Total customer payment</translate>:</b> {{ booking.currency }} {{ bookingTotal  }}
                <b-icon :icon="collapsed ? 'plus-square': 'dash-square'" scale="1.3" @click="collapsed = !collapsed" variant="info" class="float-right"/>
              </td>
            </tr>
            <tr>
              <td><b><translate>Booking no</translate>:</b> {{ booking.id}}</td>
              <td>
                <span v-if="!collapsed">
                  <b><translate>Commission</translate>:</b> {{ booking.currency }} {{ booking.commission }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b><translate>Booking status</translate>:</b> {{ booking.status}}</td>
              <td>
                <span v-if="!collapsed">
                  <b><translate>Total due</translate>:</b> {{ booking.currency }} {{ bookingTotalDue }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b><translate>Destinatio</translate>:</b> {{ booking.destination }}</td>
              <td>
                <span v-if="!collapsed">
                  <b><translate>Paid</translate>:</b> {{ booking.currency }} {{ booking.paid }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b><translate>Agent</translate>:</b> {{ booking.user }}</td>
              <td>
                <span v-if="!collapsed">
                  <b><translate>Balance due</translate>:</b> {{ booking.currency }} {{ bookingUnpaid }}
                </span>
              </td>
            </tr>
            <tr>
              <td >
                <b><translate>Agency</translate>:</b> {{ userData.companyName }}
              </td>
              <td>
                <span v-if="!collapsed">
                  <b><translate>Invoices</translate>:</b>
                  <span v-if="!booking.invoices.length"> n/a</span>
                  <a @click="downloadInvoice(invoice)" class="btn btn-outline-success btn-sm ml-2" v-for="invoice in booking.invoices" :key="invoice.id">
                    <b-icon icon="download" class="mr-2" font-scale="0.9" style="margin-bottom:3px;"/>{{ invoice.number }}<br />
                  </a>
                </span>
              </td>
            </tr>
            <tr v-if="!collapsed" >
              <td><b><translate>Payment schedule</translate>:</b> </td>
              <td>
                <span v-for="(d,dIndex) in booking.due_dates" :key="'dueDate'+dIndex">{{ booking.currency }} {{ d.amount }} {{ $gettext('due by') }} {{ d.date }}<br /></span>
                <translate>balance due by</translate> {{ booking.balance_due_date }}
              </td>
            </tr>
        </table>
        <b-card class="p-2" no-body>
          <b v-translate>Agent Notes:</b>
          <span v-for="(note, index) in booking.notes" :key="index" style="white-space: pre-line;">
            {{note.text}}
          </span>
        </b-card>
      </b-col>
      <b-col md="4" class="my-3 my-md-0">
        <h5 class="result-summary" v-translate>Passengers</h5>
        <table class="table table-striped table-sm border">
          <tbody>
            <tr v-for="(pax, paxIndex) in booking.pax" :key="paxIndex">
              <td><span class="small text-">{{pax.title + ' ' + pax.fname + ' ' + pax.lname}}</span>
              <span class="badge float-right"> {{ pax.ageGroup }} / {{ getDate(pax.bdate) }} </span></td>
            </tr>
          </tbody>
        </table>
        <h5 class="package-title" v-translate>Files attached</h5>
        <table class="table table-striped table-sm border">
          <tbody>
            <tr v-for="(file, fileIndex) in booking.attachments" :key="fileIndex">
              <td colspan="2">{{ file.title }} &ndash;
                <a target="_self" :href="file.url">{{ file.filename }}</a></td>
            </tr>
            <tr>
              <td>
                <b-form-file
                  size="sm"
                  v-model="file"
                  accept=".pdf,.jpg,.png"
                  :placeholder="$gettext('Choose a file here...')"
                  :drop-placeholder="$gettext('Drop a file here...')"
                ></b-form-file>
              </td>
              <td>
                <b-button @click="onUploadClick()" size="sm" v-translate>Send</b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr>
        <b-button
          size ="sm"
          variant="primary"
          @click="openTermsAndConditions"
          v-translate
          class="float-right"
        >Print Terms and Conditions</b-button>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row v-for="item in booking.items" :key="'item' + item.id">
      <b-col>
        <PackageItem :item="item" v-if="item.type === 'sd_package'" />
        <FlightItem :item="item" v-else-if="item.type === 'flight'" />
        <TransferItem :item="item" v-else-if="item.type === 'transfer'" />
        <HotelItem :item="item" v-else-if="item.type === 'hotel'" />
        <InsuranceItem :item="item" v-else-if="item.type === 'insurance'" />
        <div v-else>
          <h6 class="booking-details-title">{{ item.label }}</h6>
          <b-card bg-variant="light">
            <b-card-text style="white-space: pre-line;">
              {{ item.description }}
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <hr>
      </b-col>
      <b-col>
        <b-button variant="warning" size="sm" class="float-right" @click="$router.push({ name: 'Private/Bookings/Search' })"><b-icon icon="chevron-left" /><translate>Back to results</translate></b-button>
      </b-col>
    </b-row>
    <!-- {{ booking.id }} -->
    <b-modal v-model="termsAndConditions" :title="$gettext('Terms and Conditions')" size="xl" hide-header hide-footer>
      <div class="printArea">
        <SimpleModalHeader  @closeModal="closeTermsAndConditions" @download="downloadTerms" class="noPrint">
          <button class="btn btn-outline-danger btn-sm mx-2" @click="downloadTerms" v-b-tooltip.hover :title="$gettext('PDF')">
            <b-icon icon="download" />
          </button>
        </SimpleModalHeader>
        <b-card>
          <TermsAndConditions/>
          <hr>
          <b-button variant="warning" class="float-right noPrint"  @click="closeTermsAndConditions" v-translate>Close</b-button>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import http from 'b2b-common/vue-config/axios'

import { authApiURL } from 'b2b-common/utils'
import { getInvoice, downloadPdf, getCustomPdf } from 'b2b-common/services/api/document'

import authMixin from 'b2b-common/mixins/auth'

import PackageItem from './package_item_info'
import TransferItem from './transfer_item_info'
import FlightItem from './flight_item_info'
import HotelItem from './hotel_item_info'
import InsuranceItem from './insurance_item_info'
import SimpleModalHeader from '../../shared/components/simple_modal_header'
import TermsAndConditions from '../../shared/components/terms_and_conditions'

export default {
  name: 'bookingDetails',
  props: ['booking'],
  mixins: [authMixin],
  components: { PackageItem, TransferItem, FlightItem, InsuranceItem, HotelItem, TermsAndConditions, SimpleModalHeader },
  data () {
    return {
      file: null,
      collapsed: false,
      termsAndConditions: false
    }
  },
  computed: {
    bookingTotal () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax)
      return Math.ceil(n * 100) / 100
    },
    bookingTotalDue () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission)
      return Math.ceil(n * 100) / 100
    },
    bookingUnpaid () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission) - parseFloat(this.booking.paid)
      return Math.ceil(n * 100) / 100
    }
  },
  methods: {
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    async onUploadClick () {
      const formData = new FormData()
      formData.append('file', this.file)
      const res = await http.post(authApiURL,
        formData,
        {
          params: {
            action: 'attachBookingFile',
            id: this.booking.id
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      this.booking.attachments.push(res.data)
      return res.data
    },
    async downloadInvoice (invoice) {
      const pdfData = await getInvoice({ bookingId: this.booking.id, invoiceId: invoice.id })
      const fileName = this.$pgettext('file name do not use special characters, please use ASCII only', 'invoice') + '_' + invoice.number + '.pdf'
      downloadPdf({ pdfData: pdfData.pdf, fileName })
    },
    downloadTerms () {
      const arr = document.getElementsByClassName('printArea')
      let html = ''
      arr.forEach(el => {
        html += el.innerHTML
      })
      getCustomPdf({ html })
        .then(pdfData => {
          downloadPdf({ pdfData, fileName: this.$pgettext('file name do not use special characters, please use ASCII only', 'offer') + '.pdf', dataType: 'raw' })
        })
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    }
  }
}
</script>
